import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function HelpCategories() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const categories = data?.help?.categories || [];

  return (
    <MainPanel title={t('help.categoriesTitle')} subtitle={t('help.categoriesSubtitle')}>
      {categories.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('help.categoriesEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('help.categoriesEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {categories.map((cat) => (
            <div
              key={cat}
              style={{
                padding: '12px 18px',
                borderRadius: 999,
                background: '#1f2229',
                border: '1px solid rgba(255,255,255,0.08)',
                color: '#f3f4f6',
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              {cat}
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
